import { config } from 'process';
import { environment } from '../../environments/environment';

export class Config {
  constructor() { }
  public static get BASE_POINT_API() { return environment.API_END_POINT; }
  public static get SOCKET_POINT_API() { return environment.SOCKET_END_POINT; }

  public static get COMPLAINT_BASE_API() { return environment.COMPLAINT_API_END_POINT; }
  public static get AQI_BASE_POINT_API() { return environment.AQI_API_END_POINT; }
  // public static get AERMOD_BASE_POINT_API() { return environment.AERMOD_API_END_POINT; }
  public static get RESTART_SERVICE() { return environment.RESTART_SERVICE; }
  public static get MQTT_CONNECTION() { return environment.MQTT_CONNECTION; }
  public static get BASE_POINT_JSON() { return 'assets/jsons/'; }
  public static get BASE_POINT_JSON_CONSTANTS() { return 'assets/jsons/configuration/'; }
  public static get IMAGE_BASE_POINT_JSON() { return './complaints/Images/'; }
  public static GLENS_IMAGE = true;
  public static FUJERAH_IMAGE = true;

  public static BASE_API_MAPPING = {
    common: Config.BASE_POINT_API + '',
    // common: 'http://192.168.1.62:7347/kl/GLensClient/',
    aqiCommon: Config.AQI_BASE_POINT_API + '',
    complaint: Config.COMPLAINT_BASE_API + '',
    // aermod: Config.AERMOD_BASE_POINT_API + 'api/',
    restart: Config.RESTART_SERVICE + '',
    socket: Config.SOCKET_POINT_API + 'kl/GLensClient/'
  };
  // Json Base Points
  public static JSON = {
    // login
    login: Config.BASE_POINT_JSON + 'login.json',
    navHeader: Config.BASE_POINT_JSON + 'navHeader.json',
    message: Config.BASE_POINT_JSON + 'message.json',
    navHeaderDescription: Config.BASE_POINT_JSON + 'navHeaderDescription.json',
    navHeaderInfoIcon: Config.BASE_POINT_JSON + 'descriptionIcon.json',
    customAlertTable: Config.BASE_POINT_JSON + 'custom-alert-table.json',
    fetchAlertForms: Config.BASE_POINT_JSON + 'customAlertFormData.json',
    blowBackSetupForm: Config.BASE_POINT_JSON + 'blowBackSetupForm.json',
    fetchUserTable: Config.BASE_POINT_JSON + 'custom-alert-user.json',
    fetchLevelTable: Config.BASE_POINT_JSON + 'custom-alert-level.json',
    fetchAlertTable: Config.BASE_POINT_JSON + 'custom-alert-alert.json',
    fetchLimitTable: Config.BASE_POINT_JSON + 'custom-alert-limit.json',
    // reports
    iedReportCreate: Config.BASE_POINT_JSON + 'iedReportCreate.json',
    iedreportloader: Config.BASE_POINT_JSON + 'iedreportloader.json',
    averageReportLoader: Config.BASE_POINT_JSON + 'averageReportLoader.json',
    alarmReportLoader: Config.BASE_POINT_JSON + 'alarmReportLoader.json',
    requestMatrixdata: Config.BASE_POINT_JSON + 'requestMatrixdata.json',
    requestShiftReports: Config.BASE_POINT_JSON + 'requestShiftReports.json',
    requestAverageReport: Config.BASE_POINT_JSON + 'requestAverageReport.json',
    requestMultipleAverageReport: Config.BASE_POINT_JSON + 'requestMultipleAverageReport.json',
    requestDailyReport: Config.BASE_POINT_JSON + 'requestDailyReport.json',
    requestMonthlyAverage: Config.BASE_POINT_JSON + 'requestMonthlyAverage.json',
    requestDynamicReport: Config.BASE_POINT_JSON + 'requestDynamicReport.json',
    dynamicLiveData: Config.BASE_POINT_JSON + 'dynamicLiveData.json',
    requestTotalizerReport: Config.BASE_POINT_JSON + 'requestTotalizerReport.json',
    hourlyExceedance: Config.BASE_POINT_JSON + 'hourlyExceedance.json',
    exceedanceReportLoader: Config.BASE_POINT_JSON + 'exceedanceReportLoader.json',
    calculateAverageExceedance: Config.BASE_POINT_JSON + 'calculateAverageExceedance.json',
    batchReportLoader: Config.BASE_POINT_JSON + 'batchReportLoader.json',
    editBatchReportDetails: Config.BASE_POINT_JSON + 'editBatchReportDetails.json',

    fetchAverageData: Config.BASE_POINT_JSON + 'averageSummary.json',
    getMetroData: Config.BASE_POINT_JSON + 'meterologicReportTable.json',
    requestParameterSummary: Config.BASE_POINT_JSON + 'parameterSummary.json',
    requestRealTimeReport: Config.BASE_POINT_JSON + 'requestRealTimeReport.json',
    saveTimeIntervel: Config.BASE_POINT_JSON + 'saveTimeIntervel.json',
    requestSiteInfo: Config.BASE_POINT_JSON + 'siteInfo.json',
    // others
    fetchAuditAlarm: Config.BASE_POINT_JSON + 'fetchAuditAlarm.json',
    todayAlarm: Config.BASE_POINT_JSON + 'todayAlarm.json',
    requestHeadersStationwiseReport: Config.BASE_POINT_JSON + 'requestHeadersStationwiseReport.json',
    monthlySummaryGraphLoader: Config.BASE_POINT_JSON + 'monthlySummaryGraphLoader.json',
    rawGraphLoader: Config.BASE_POINT_JSON + 'rawGraphLoader.json',
    requestHeadersDynamicLiveData: Config.BASE_POINT_JSON + 'requestHeadersDynamicLiveData.json',
    requestHeadersIEDComplainceReport: Config.BASE_POINT_JSON + 'requestHeadersIEDComplainceReport.json',
    iedComplainceGraphLoader: Config.BASE_POINT_JSON + 'iedComplainceGraphLoader.json',
    scheduledGraphLoader: Config.BASE_POINT_JSON + 'scheduledGraphLoader.json',
    parameterSelectionReportLoader: Config.BASE_POINT_JSON + 'parameterSelectionReportLoader.json',
    requestHeadersWindrose: Config.BASE_POINT_JSON + 'requestHeadersWindrose.json',
    getTableDataBasedOnSite: Config.BASE_POINT_JSON + 'getTableDataBasedOnSite.json',
    staticFilters: Config.BASE_POINT_JSON + 'staticFilters.json',
    escalationMatrixView: Config.BASE_POINT_JSON + 'escalationMatrixView.json',
    featuresMapping: Config.BASE_POINT_JSON_CONSTANTS + 'featuresMapping.json',
    constants: Config.BASE_POINT_JSON_CONSTANTS + 'constants.json',

    // Analytic Reports
    requestHistogramReport: Config.BASE_POINT_JSON + 'requestHistogramReport.json',
    getWindRose: Config.BASE_POINT_JSON + 'getWindRose.json',
    requestPercentileReport: Config.BASE_POINT_JSON + 'requestPercentileReport.json',
    requestUptimeReport: Config.BASE_POINT_JSON + 'requestUptimeReport.json',
    requestScatterReport: Config.BASE_POINT_JSON + 'requestScatterReport.json',
    normalizationVerifyData: Config.BASE_POINT_JSON + 'normalizationVerifyData.json',
    saveAnalytics: Config.BASE_POINT_JSON + 'saveAnalytics.json',
    analyticsReportLoad: Config.BASE_POINT_JSON + 'analytics_report_load.json',
    getPolarisedWindrose: Config.BASE_POINT_JSON + 'getPolarisedWindrose.json',
    requestAllAnalytics: Config.BASE_POINT_JSON + 'requestAllAnalytics.json',

    // realtime
    newDashboardView: Config.BASE_POINT_JSON + 'newDashboardView.json',
    siteList: Config.BASE_POINT_JSON + 'siteList.json',
    sitedetails: Config.BASE_POINT_JSON + 'sitedetails.json',
    stationData: Config.BASE_POINT_JSON + 'stationData.json',
    geoJSON: Config.BASE_POINT_JSON + 'geoJSON.json',
    geochartmapLoaderDM: Config.BASE_POINT_JSON + 'geochartmapLoaderDM.json',
    geomapLoaderDashboardDM: Config.BASE_POINT_JSON + 'geochartmapDashboardDM.json',
    getStationInfo: Config.BASE_POINT_JSON + 'getStationInfo.json',
    getSitesList: Config.BASE_POINT_JSON + 'getSitesList.json',
    siteParameterStatus: Config.BASE_POINT_JSON + 'siteParameterStatus.json',
    allMetReports: Config.BASE_POINT_JSON + 'allMetReport.json',
    dataAvailabilityReport: Config.BASE_POINT_JSON + 'dataAvailabilityReport.json',
    fetchLiveData: Config.BASE_POINT_JSON + 'fetchLiveData.json',
    fetchDashboardDataDM: Config.BASE_POINT_JSON + 'liveDashboardDM.json',
    siteStatus: Config.BASE_POINT_JSON + 'siteStatus.json',
    publicAqiMap: Config.BASE_POINT_JSON + 'publicAqiMap.json',
    fetchStationParamData: Config.BASE_POINT_JSON + 'fetchStationParamData.json',
    hindalcoDashboardData: Config.BASE_POINT_JSON + 'hindalcoDashboardData.json',

    // Maintenance
    maintenanceLoader: Config.BASE_POINT_JSON + 'maintenanceLoader.json',
    maintenanceReport: Config.BASE_POINT_JSON + 'maintenanceReport.json',
    operationSetup: Config.BASE_POINT_JSON + 'operationSetup.json',

    // diagnostic
    diagnosticsReport: Config.BASE_POINT_JSON + 'diagnosticsReport.json',
    diagnosticParameterReport: Config.BASE_POINT_JSON + 'diagnosticParameterReport.json',

    // Calibration
    calibrationLoader: Config.BASE_POINT_JSON + 'calibrationLoader.json',
    calibrationFilter: Config.BASE_POINT_JSON + 'calibrationFilter.json',
    fetchTrigger: Config.BASE_POINT_JSON + 'fetchTrigger.json',
    qualitycontrolcharts: Config.BASE_POINT_JSON + 'qualitycontrolcharts.json',
    requestCusumReport: Config.BASE_POINT_JSON + 'requestCusumReport.json',
    requestEwmaReport: Config.BASE_POINT_JSON + 'requestEwmaReport.json',
    requestShewhartReport: Config.BASE_POINT_JSON + 'requestShewhartReport.json',
    callibrationReprot: Config.BASE_POINT_JSON + 'callibrationReprot.json',
    remoteCalibrationStatus: Config.BASE_POINT_JSON + 'remoteCalibrationStatus.json',
    calendarCalibration: Config.BASE_POINT_JSON + 'calendarCalibration.json',
    addQual2: Config.BASE_POINT_JSON + 'qual2Add.json',
    loadQual2Table: Config.BASE_POINT_JSON + 'q2Table.json',
    q2astTable: Config.BASE_POINT_JSON + 'qual2Table.json',

    // audit logs
    requestauditLog: Config.BASE_POINT_JSON + 'requestauditLog.json',
    glensVersions: Config.BASE_POINT_JSON + 'glensVersions.json',
    filterParameter: Config.BASE_POINT_JSON + 'filterParameter.json',
    // comments
    FetcheComment: Config.BASE_POINT_JSON + 'FetcheComment.json',
    PostDataValidation: Config.BASE_POINT_JSON + 'PostDataValidation.json',

    // site setup
    loadSiteDetails: Config.BASE_POINT_JSON + 'loadSiteDetails.json',
    advancedSetupLoader: Config.BASE_POINT_JSON + 'advancedSetupLoader.json',
    loadNormalization: Config.BASE_POINT_JSON + 'loadNormalization.json',
    loadNormalizationFilter: Config.BASE_POINT_JSON + 'loadNormalizationFilter.json',
    loadFilter: Config.BASE_POINT_JSON + 'loadFilter.json',
    siteConfigLoad: Config.BASE_POINT_JSON + 'siteConfigLoad.json',
    loadAddUserFilter: Config.BASE_POINT_JSON + 'loadAddUserFilter.json',
    loadUser: Config.BASE_POINT_JSON + 'loadUser.json',
    loadPasswordChangeModal: Config.BASE_POINT_JSON + 'loadPasswordChangeModal.json',
    fuelSetup: Config.BASE_POINT_JSON + 'fuelSetup.json',
    loadAddFuelFilter: Config.BASE_POINT_JSON + 'loadAddFuelFilter.json',
    networkDetails: Config.BASE_POINT_JSON + 'networkDetails.json',
    loadAddNetwork: Config.BASE_POINT_JSON + 'loadAddNetwork.json',
    fetchShift: Config.BASE_POINT_JSON + 'fetchShift.json',
    loadAddGeneralFilter: Config.BASE_POINT_JSON + 'loadAddGeneralFilter.json',
    loadStationDetails: Config.BASE_POINT_JSON + 'loadStationDetails.json',
    loadAddMonitoringStation: Config.BASE_POINT_JSON + 'loadAddMonitoringStation.json',
    loadCollector: Config.BASE_POINT_JSON + 'loadCollector.json',
    loadAddCollector: Config.BASE_POINT_JSON + 'loadAddCollector.json',
    loadAddValueCollector: Config.BASE_POINT_JSON + 'loadAddValueCollector.json',
    cylinderSetupLoader: Config.BASE_POINT_JSON + 'cylinderSetupLoader.json',
    loadAddNewCylinder: Config.BASE_POINT_JSON + 'loadAddNewCylinder.json',
    smsLoader: Config.BASE_POINT_JSON + 'smsLoader.json',
    loadAddSms: Config.BASE_POINT_JSON + 'loadAddSms.json',
    loadFeatures: Config.BASE_POINT_JSON + 'loadFeatures.json',
    loadAddUserRole: Config.BASE_POINT_JSON + 'loadAddUserRole.json',
    alertMailConfigLoader: Config.BASE_POINT_JSON + 'alertMailConfigLoader.json',
    displayLoad: Config.BASE_POINT_JSON + 'displayLoad.json',
    displayBoardWindow: Config.BASE_POINT_JSON + 'displayBoardWindow.json',
    displayAdd: Config.BASE_POINT_JSON + 'loadDisplaySave.json',
    parameterSetupLoader: Config.BASE_POINT_JSON + 'parameterSetupLoader.json',
    loadAddParameter: Config.BASE_POINT_JSON + 'loadAddParameter.json',
    loadActiveTable: Config.BASE_POINT_JSON + 'loadActiveTable.json',
    loadActiveSearchTable: Config.BASE_POINT_JSON + 'activeDirectorySearch.json',
    saveMonitoringData: Config.BASE_POINT_JSON + 'saveMonitoringData.json',
    fetchiedpm1: Config.BASE_POINT_JSON + 'iedpm1Fetch.json',
    loadDynamicLimits: Config.BASE_POINT_JSON + 'loadDynamicLimits.json',
    fetchiedaqra: Config.BASE_POINT_JSON + 'iedaqraFetch.json',
    loadAermodMonitoringStation: Config.BASE_POINT_JSON + 'loadAermodMonitoringStation.json',
    dubaiDMGeoJson: Config.BASE_POINT_JSON + 'dubaiDMGeoJson.json',
    loadFlagsetup: Config.BASE_POINT_JSON + 'loadFlagsetup.json',
    loadFlagSetupForm: Config.BASE_POINT_JSON + 'loadFlagSetupForm.json',
    loadQualifierCodeSetupForm: Config.BASE_POINT_JSON + 'loadQualifierCodeSetupForm.json',
    loadQualifierCodeSetup: Config.BASE_POINT_JSON + 'loadQualifierCodeSetup.json',
    loadCommentssetup: Config.BASE_POINT_JSON + 'loadCommentssetup.json',
    loadCommentSetupForm: Config.BASE_POINT_JSON + 'loadCommentSetupForm.json',
    loadCategorySetup: Config.BASE_POINT_JSON + 'loadCategorySetup.json',
    loadCategorySetupForm: Config.BASE_POINT_JSON + 'loadCategorySetupForm.json',
    dm_standard_view: Config.BASE_POINT_JSON + 'dm_standard_view.json',
    mailServiceList: Config.BASE_POINT_JSON + 'mailServiceList.json',
    mailServiceAdd: Config.BASE_POINT_JSON + 'mailServiceAdd.json',
    mailServiceFieldData: Config.BASE_POINT_JSON + 'mailServiceFieldData.json',
    // batch running
    batchesList: Config.BASE_POINT_JSON + 'batchesList.json',
    changebatchStatus: Config.BASE_POINT_JSON + 'batchesList.json',
    addBatch: Config.BASE_POINT_JSON + 'addBatch.json',
    fetchBatch: Config.BASE_POINT_JSON + 'fetchBatch.json',
    fetchBatchForm: Config.BASE_POINT_JSON + 'fetchBatchForm.json',


    // service-operations
    fetchServicesList: Config.BASE_POINT_JSON + 'fetchServicesList.json',


    // common success
    commonSuccessJson: Config.BASE_POINT_JSON + 'commonSuccessJson.json',

    // printer
    CsvDump: Config.BASE_POINT_JSON + 'CsvDump.json',
    PdfDump: Config.BASE_POINT_JSON + 'PdfDump.json',
    excelDump: Config.BASE_POINT_JSON + 'excelDump.json',

    // AQI Reports
    AQIDataReport: Config.BASE_POINT_JSON + 'AQIDataReport.json',
    AQILevelReport: Config.BASE_POINT_JSON + 'AQILevelReport.json',
    AQIHourlyCalenderView: Config.BASE_POINT_JSON + 'AQIHourlyCalenderView.json',
    AQIMonthlyCalenderView: Config.BASE_POINT_JSON + 'AQIMonthlyCalenderView.json',


    // complaints
    complaintsManagementFilter: Config.BASE_POINT_JSON + 'complaintsManagementFilter.json',
    complaintManagementTableLoader: Config.BASE_POINT_JSON + 'complaintManagementTableLoader.json',
    complaintManagementTabLoader: Config.BASE_POINT_JSON + 'complaintManagementTab.json',
    viewComplaintLoader: Config.BASE_POINT_JSON + 'complaintView.json',
    deleteComplaintLoader: Config.BASE_POINT_JSON + 'deleteComplaintLoader.json',
    inspectionOnload: Config.BASE_POINT_JSON + 'complaintEntryFields.json',
    complaintEnteredFields: Config.BASE_POINT_JSON + 'complaintEnteredFields.json',
    inspectionTable: Config.BASE_POINT_JSON + 'complaintsMultiheaderTable.json',
    editInspection: Config.BASE_POINT_JSON + 'editInspectionDetails.json',
    AQMSTableData: Config.BASE_POINT_JSON + 'AQMSTableData.json',
    inspectionFormJson: Config.BASE_POINT_JSON + 'requestMaintenanceLoader.json',
    addInspection: Config.BASE_POINT_JSON + 'addInspection.json',

    // aermod
    get_all_projects: Config.BASE_POINT_JSON + 'get_all_projects.json',
    get_project_generated: Config.BASE_POINT_JSON + 'get_project_generated.json',
    fetch_all_sites: Config.BASE_POINT_JSON + 'fetch_all_sites.json',
    fetch_site_metadata: Config.BASE_POINT_JSON + 'fetch_site_metadata.json',
    fetch_list_of_buildings: Config.BASE_POINT_JSON + 'fetch_list_of_buildings.json',
    get_site_terrain_details: Config.BASE_POINT_JSON + 'get_site_terrain_details.json',

    // data validation
    dataValidationTable: Config.BASE_POINT_JSON + 'dataValidationTable.json',
    // AqiDataEntry
    fetchAqiDataEntryList: Config.BASE_POINT_JSON + 'fetchAqiDataEntryList.json',
    fetchAqiDataEntryForm: Config.BASE_POINT_JSON + 'fetchAqiDataEntryForm.json',
    aqiEntryParamsMetaData: Config.BASE_POINT_JSON + 'aqiEntryParamsMetaData.json',

    // Map View
    epdaGeoJson: Config.BASE_POINT_JSON + 'epdaGeo.json',

    // Noise Modelling Test
    // noiseModellingForm: Config.BASE_POINT_JSON + 'noiseModellingForm.json',
    noiseModellingTable: Config.BASE_POINT_JSON + 'noiseModellingTable.json',
    noiseModellingHeatMap: Config.BASE_POINT_JSON + 'noiseModellingHeatMap.json',

    // Camera Dashboard
    siteData: Config.BASE_POINT_JSON + 'cameraDashboard.json',
    // Scada view
    getSldList: Config.BASE_POINT_JSON + 'getSldList.json',
    getFilteredSites: Config.BASE_POINT_JSON + 'getFilteredSites.json',
    get_sld_data: Config.BASE_POINT_JSON + 'getTemplate.json',
    getwritterTopics: Config.BASE_POINT_JSON + 'get_topic_list.json',
    getHMICurrentUserDetails: Config.BASE_POINT_JSON + 'current_user_details.json',
    getHighAvailabilityTags: Config.BASE_POINT_JSON + 'high_availibity_topics.json',
    widget_details: Config.BASE_POINT_JSON + 'widget_details.json',
    get_sld_tag_extention: Config.BASE_POINT_JSON + 'tags.json',
    getReportMenus: Config.BASE_POINT_JSON + 'reportList.json',
    getUserWorkGroupList: Config.BASE_POINT_JSON + 'user_workgroup_list.json',
    saveWidgetConfigData: Config.BASE_POINT_JSON + 'widget_save.json',
    getWidgetDetails: Config.BASE_POINT_JSON + 'widget_details.json',
    download_hmi_file: Config.BASE_POINT_API + 'hmi_export.json',

    // Camera Setup
    addCameraForm: Config.BASE_POINT_JSON + 'addCamera.json',

    // others
    dataValidationStatic: Config.BASE_POINT_JSON + 'dataValidationStatic.json',

    //Collector setup
    CollectorFilter: Config.BASE_POINT_JSON + 'collectorFilter.json',

    //Playback camera
    playbackCamera: Config.BASE_POINT_JSON + 'playbackCamera.json',
    playbackCameraModal: Config.BASE_POINT_JSON + 'playbackCameraModal.json',

    //Utilities
    uModbusUtility: Config.BASE_POINT_JSON + 'uModbusUtility.json',
    uModbusScan: Config.BASE_POINT_JSON + 'uModbusScan.json',

    //About page
    aboutJson: Config.BASE_POINT_JSON + 'about.json',

    //Workflows
    addFilters: Config.BASE_POINT_JSON + 'addWorkflow.json',
    workFlowTable: Config.BASE_POINT_JSON + 'workFlowTable.json',

    //alert setup hindalco
    alertSetupHindalcoAdd: Config.BASE_POINT_JSON + 'alertSetupHindalcoAdd.json',
    alertSetupList: Config.BASE_POINT_JSON + 'alertSetupHindalcoList.json',
    matrixTableData: Config.BASE_POINT_JSON + 'alertMatrixTableData.json',
    deleteExceedanceAlert: Config.BASE_POINT_JSON + "deleteExceedanceAlert.json",

    loadUserRole: Config.BASE_POINT_JSON + 'loadUserRole.json',
    requestEPDACustomReport: Config.BASE_POINT_JSON + 'getEPDACustomReportLoader.json',
    getFormJsonLoader: Config.BASE_POINT_JSON + 'getFormJsonLoader.json',

    // Calibration Certificate
    loadConfiguredSitesJson: Config.BASE_POINT_JSON + 'loadConfiguredSites.json',
    loadConfiguredStationsJson: Config.BASE_POINT_JSON + 'loadConfiguredStations.json',
    loadConfiguredTableDataJson: Config.BASE_POINT_JSON + 'loadConfiguredTableData.json',
    calibrationCertificateJson: Config.BASE_POINT_JSON + 'calibrationCertificateUpload.json',

    // USA Part 60 Reports
    getUsaPart60Reports: Config.BASE_POINT_JSON + 'usaPart60Reports.json',
    getUsaPart60SiteList: Config.BASE_POINT_JSON + 'usaPart60SiteList.json',
    editUsaPart60Reports: Config.BASE_POINT_JSON + 'editUSAPart60Reports.json',

    // Thermofisher Utility
    getThermofisherDasboard: Config.BASE_POINT_JSON + 'getThermofisherDasboard.json',
    
  };

  // API END POINTS
  public static API = {

    generateCheckKey: Config.BASE_API_MAPPING.common + 'generateCheckKey',
    login: Config.BASE_API_MAPPING.common + 'login',
    message: Config.BASE_API_MAPPING.common + 'message',
    // navHeader: Config.BASE_API_MAPPING.common + 'navHeader',
    navHeader: Config.BASE_API_MAPPING.common + 'siteDashboardLoader',
    getTableDataBasedOnSite: Config.BASE_API_MAPPING.common + 'averageReportLoader',
    fetchAuditAlarm: Config.BASE_API_MAPPING.common + 'fetchAuditAlarm',
    todayAlarm: Config.BASE_API_MAPPING.common + 'todayAlarm',
    siteDashboardTabLoader: Config.BASE_API_MAPPING.common + 'siteDashboardTabLoader',
    staticFilters: Config.BASE_API_MAPPING.common + 'staticFilters',
    geoJSON: Config.BASE_API_MAPPING.common + 'geoJSON',
    constantsInsert: Config.BASE_API_MAPPING.common + 'constantsInsert',
    fetchUserTable: Config.BASE_API_MAPPING.common + 'alertUserSetup',
    userInsert: Config.BASE_API_MAPPING.common + 'alertUserInsert',
    userDelete: Config.BASE_API_MAPPING.common + 'alertUserDelete',
    userUpdate: Config.BASE_API_MAPPING.common + 'alertUserEdit',
    fetchLimitTable: Config.BASE_API_MAPPING.common + 'alertLimitSetup',
    limitInsert: Config.BASE_API_MAPPING.common + 'alertLimitInsert',
    limitDelete: Config.BASE_API_MAPPING.common + 'alertLimitDelete',
    limitUpdate: Config.BASE_API_MAPPING.common + 'alertLimitEdit',
    fetchAlertTable: Config.BASE_API_MAPPING.common + 'alertDetailsSetup',
    alertInsert: Config.BASE_API_MAPPING.common + 'alertDetailsInsert',
    alertDelete: Config.BASE_API_MAPPING.common + 'alertDetailsDelete',
    alertUpdate: Config.BASE_API_MAPPING.common + 'alertDetailsEdit',
    fetchLevelTable: Config.BASE_API_MAPPING.common + 'alertLevelSetup',
    levelInsert: Config.BASE_API_MAPPING.common + 'alertLevelInsert',
    levelDelete: Config.BASE_API_MAPPING.common + 'alertLevelDelete',
    levelUpdate: Config.BASE_API_MAPPING.common + 'alertLevelUpdate',
    verifyDomainPort: Config.BASE_API_MAPPING.common + 'alertDetailsInsert',
    configLoader: Config.BASE_API_MAPPING.common + 'configLoader',
    purgeLoader: Config.BASE_API_MAPPING.common + 'purgeLoader',
    saveConfig: Config.BASE_API_MAPPING.common + 'configSave',
    immediateTrigger: Config.BASE_API_MAPPING.common + 'immediateTrigger',
    matrixSetup: Config.BASE_API_MAPPING.common + 'alertMatrixSetup',
    matrixDetails: Config.BASE_API_MAPPING.common + 'alertMatrix1Setup',
    matrixAdd: Config.BASE_API_MAPPING.common + 'alertMatrixInsert',
    matrixEdit: Config.BASE_API_MAPPING.common + 'alertMatrixEdit',
    matrixDelete: Config.BASE_API_MAPPING.common + 'alertMatrixDelete',
    enableParameter: Config.BASE_API_MAPPING.common + 'enableParameter',
    iedReportDownload: Config.BASE_API_MAPPING.common + 'ied_services',
    fetchSiteDetails: Config.BASE_API_MAPPING.common + 'fetchSiteDetails',
    fetchStationDetails: Config.BASE_API_MAPPING.common + 'fetchStationDetails',
    parameterAlertDetails: Config.BASE_API_MAPPING.common + 'parameterAlertDetails',
    internetStatus: Config.BASE_API_MAPPING.common + 'internetStatus',
    // reports
    iedReportCreate: Config.BASE_API_MAPPING.common + 'iedReportCreate',
    iedreportloader: Config.BASE_API_MAPPING.common + 'iedreportloader',
    averageReportLoader: Config.BASE_API_MAPPING.common + 'averageReportLoader',
    alarmReportLoader: Config.BASE_API_MAPPING.common + 'alarmReportLoader',
    requestMatrixdata: Config.BASE_API_MAPPING.common + 'requestMatrixdata',
    requestShiftReports: Config.BASE_API_MAPPING.common + 'requestShiftReports',
//  requestFortnightReports :'http://ac9aca203d3f.ngrok.io/kl/GLensClient/requestFortnightReports',
//    requestShiftReports :'http://ac9aca203d3f.ngrok.io/kl/GLensClient/requestShiftReports',

    requestAverageReport: Config.BASE_API_MAPPING.common + 'requestAverageReport',
    saveTimeIntervel: Config.BASE_API_MAPPING.common + 'saveTimeIntervel',

    requestSiteInfo: Config.BASE_API_MAPPING.common + 'requestSiteInfo',
    requestRealTimeReport: Config.BASE_API_MAPPING.common + 'requestRealTimeReport',
    requestMultipleAverageReport: Config.BASE_API_MAPPING.common + 'requestMultipleAverageReport',
    requestDailyReport: Config.BASE_API_MAPPING.common + 'requestDailyReport',
    requestMonthlyAverage: Config.BASE_API_MAPPING.common + 'requestMonthlyAverage',
    requestDynamicReport: Config.BASE_API_MAPPING.common + 'requestDynamicReport',
    dynamicLiveData: Config.BASE_API_MAPPING.common + 'dynamicLiveData',
    requestTotalizerReport: Config.BASE_API_MAPPING.common + 'requestTotalizerReport',
    dynamicLiveReportGraphLoader: Config.BASE_API_MAPPING.common + 'dynamicLiveReportGraphLoader',
    requestFortnightReports: Config.BASE_API_MAPPING.common + 'requestFortnightReports',
    iedPdfHandler: Config.BASE_API_MAPPING.common + 'iedPdfHandler',
    hourlyExceedance: Config.BASE_API_MAPPING.common + 'hourlyExceedance',
    exceedanceReportLoader: Config.BASE_API_MAPPING.common + 'exceedanceReportLoader',
    dataAvailabilityReport: Config.BASE_API_MAPPING.common + 'dataAvailabilityReport',
    calculateAverageExceedance: Config.BASE_API_MAPPING.common + 'calculateAverageExceedance',
    calculateAverageProactiveness: Config.BASE_API_MAPPING.common + 'calculateAverageProactiveness',
    acknowledgeExceedance: Config.BASE_API_MAPPING.common + 'acknowledgeExceedance',
    acknowledgeProactive: Config.BASE_API_MAPPING.common + 'acknowledgeProactive',
    getMetrologicalReports: Config.BASE_API_MAPPING.common + 'getMetrologicalReports',
    scheduleReport: Config.BASE_API_MAPPING.common + 'scheduleReport', // 'batchReportLoader',
    addBatchReportDetails: Config.BASE_API_MAPPING.common + 'submitReport', // addBatchReportDetails',
    editBatchReportDetails: Config.BASE_API_MAPPING.common + 'editReport', // 'editBatchReportDetails',
    deleteBatchReport: Config.BASE_API_MAPPING.common + 'deleteReport', // 'deleteBatchReport',
    fetchScheduleDetails: Config.BASE_API_MAPPING.common + 'fetchScheduleDetails',
    getBatchCSVReport: Config.BASE_API_MAPPING.common + 'getBatchCSVReport',
    getBatchPDFReport: Config.BASE_API_MAPPING.common + 'getBatchPDFReport',
    requestParameterSummary: Config.BASE_API_MAPPING.common + 'requestParameterSummary',
    fetchAverageData: Config.BASE_API_MAPPING.common + 'fetchAverageData',
    requestDataAvailabilityDayWiseReport: Config.BASE_API_MAPPING.common + 'requestDataAvailabilityDayWiseReport',
    requestHeadersDynamicLiveData: Config.BASE_API_MAPPING.common + 'requestHeadersDynamicLiveData',
    epdaCustomSummaryReport: Config.BASE_API_MAPPING.common + 'EPDASummaryReports',
    epdaCustomReportExcelExport: Config.BASE_API_MAPPING.common + 'generateXLReportEPDA',
    epdaCustomReport: Config.BASE_API_MAPPING.common + 'epdaCustomReport',

    // DIURNAL REPORT
    requestDiurnalReport: Config.BASE_API_MAPPING.common + 'requestDiurnalReport',

    // realtime report
    newDashboardView: Config.BASE_API_MAPPING.common + 'newDashboardView',
    siteList: Config.BASE_API_MAPPING.common + 'siteList',
    sitedetails: Config.BASE_API_MAPPING.common + 'sitedetails',
    mapSiteDetails: Config.BASE_API_MAPPING.common + 'mapSiteDetails',
    rawSitedetails: Config.BASE_API_MAPPING.common + 'rawSitedetails',
    sequenceOrder: Config.BASE_API_MAPPING.common + 'sequenceorder',
    stationData: Config.BASE_API_MAPPING.common + 'stationData',
    geochartmapLoader: Config.BASE_API_MAPPING.common + 'geoChartMapLoader',
    geochartmapLoaderDM: Config.BASE_API_MAPPING.common + 'geochartmapLoaderDM',
    siteDashboardDetails: Config.BASE_API_MAPPING.common + 'siteDashboardDetails',
    getSitesList: Config.BASE_API_MAPPING.common + 'getSitesList',
    publicAqiMap: Config.BASE_API_MAPPING.common + 'publicAqiMap',
    standard_metadata: Config.BASE_API_MAPPING.common + 'standard_metadata',
    paramChart: Config.BASE_API_MAPPING.common + 'paramChart',
    siteParameterStatus: Config.BASE_API_MAPPING.common + 'siteParameterStatus',
    allMetReports: Config.BASE_API_MAPPING.common + 'allMetReports',
    analyticsReportLoad: Config.BASE_API_MAPPING.common + 'analyticsReportLoad',
    fetchLiveData: Config.BASE_API_MAPPING.common + 'fetchLiveData',
    fetchDashboardDataDM: Config.BASE_API_MAPPING.common + 'fetchDashboardDataDM',
    siteStatus: Config.BASE_API_MAPPING.common + 'stationStatus',
    fetchStationParamData: Config.BASE_API_MAPPING.common + 'fetchStationDataDM',
    // Analytic Reports
    requestHistogramReport: Config.BASE_API_MAPPING.common + 'requestHistogramReport',
    getWindRose: Config.BASE_API_MAPPING.common + 'getWindRose',
    requestPercentileReport: Config.BASE_API_MAPPING.common + 'requestPercentileReport',
    requestUptimeReport: Config.BASE_API_MAPPING.common + 'requestUptimeReport',
    requestScatterReport: Config.BASE_API_MAPPING.common + 'requestScatterReport',
    requestAllAnalytics: Config.BASE_API_MAPPING.common + 'rShiny',
    normalizationVerifyData: Config.BASE_API_MAPPING.common + 'normalizationVerifyData',
    saveAnalytics: Config.BASE_API_MAPPING.common + 'save_analytics',
    getPolarisedWindrose: Config.BASE_API_MAPPING.common + 'getPolarisedWindrose',
    // Maintenance
    maintenanceLoader: Config.BASE_API_MAPPING.common + 'maintenanceLoader',
    saveMaintenance: Config.BASE_API_MAPPING.common + 'saveMaintenance',
    maintenanceReport: Config.BASE_API_MAPPING.common + 'maintenanceReport',
    operationSetup: Config.BASE_API_MAPPING.common + 'operationSetup',
    operatingFilters: Config.BASE_API_MAPPING.common + 'operatingFilters',
    operationhrsInsert: Config.BASE_API_MAPPING.common + 'operationhrsInsert',
    updateOperatingHours: Config.BASE_API_MAPPING.common + 'updateOperatingHours',
    deleteOperationSetup: Config.BASE_API_MAPPING.common + 'deleteOperationSetup',

    // diagnostic
    diagnosticsReport: Config.BASE_API_MAPPING.common + 'diagnosticsReport',
    diagnosticParameterReport: Config.BASE_API_MAPPING.common + 'diagnosticParameterReport',
    analyserStatus: Config.BASE_API_MAPPING.common + 'analyserStatus',
    requestdiagnosticsParamLoader: Config.BASE_API_MAPPING.common + 'requestdiagnosticsParamLoader',
    requestdiagnosticsLoader: Config.BASE_API_MAPPING.common + 'requestdiagnosticsLoader',

    // calibration
    calibrationLoader: Config.BASE_API_MAPPING.common + 'calibrationLoader',
    fetchTrigger: Config.BASE_API_MAPPING.common + 'fetchTrigger',
    qualitycontrolcharts: Config.BASE_API_MAPPING.common + 'qualitycontrolcharts',
    requestCusumReport: Config.BASE_API_MAPPING.common + 'requestCusumReport',
    requestEwmaReport: Config.BASE_API_MAPPING.common + 'requestEwmaReport',
    requestShewhartReport: Config.BASE_API_MAPPING.common + 'requestShewhartReport',
    callibrationReprot: Config.BASE_API_MAPPING.common + 'callibrationReprot',
    remoteCalibrationStatus: Config.BASE_API_MAPPING.common + 'remoteCalibrationStatus',
    calendarCalibration: Config.BASE_API_MAPPING.common + 'calendarCalibration',
    addSequence: Config.BASE_API_MAPPING.common + 'addSequence',
    approvecalibration: Config.BASE_API_MAPPING.common + 'approvecalibration',
    trigSequence: Config.BASE_API_MAPPING.common + 'trigSequence',

    // form Jsons
    formJsonLoader: Config.BASE_API_MAPPING.common + 'formJsonLoader',

    // audit logs
    requestauditLog: Config.BASE_API_MAPPING.common + 'requestauditLog',
    glensVersions: Config.BASE_API_MAPPING.common + 'glensVersions',

    // Comments
    fetcheComment: Config.BASE_API_MAPPING.common + 'fetcheComment',
    PostDataValidation: Config.BASE_API_MAPPING.common + 'PostDataValidation',

    // Data Validation
    fetchSites: Config.BASE_API_MAPPING.common + 'fetchSites',
    siteParameter: Config.BASE_API_MAPPING.common + 'siteParameter',
    dataValidationTable: Config.BASE_API_MAPPING.common + 'dataValidationTable',
    submitDataValidation: Config.BASE_API_MAPPING.common + 'submitDataValidation',
    allMetadataSubmit: Config.BASE_API_MAPPING.common + 'allMetadataSubmit',
    revertDataValidation: Config.BASE_API_MAPPING.common + 'revertDataValidation',
    fetchDataValidationConstants: Config.BASE_API_MAPPING.common + 'fetchDataValidationConstants',

    // site setup
    saveCatchmentArea: Config.BASE_API_MAPPING.common + 'saveCatchmentArea',
    siteSetupLoader: Config.BASE_API_MAPPING.common + 'siteSetupLoader',
    setupStationLoader: Config.BASE_API_MAPPING.common + 'setupStationLoader',
    sortingstation: Config.BASE_API_MAPPING.common + 'sortingstation',
    geoLocation: Config.BASE_API_MAPPING.common + 'geoLocation',
    cameraCapture: Config.BASE_API_MAPPING.common + 'cameraCapture',
    addStation: Config.BASE_API_MAPPING.common + 'addStation',
    loadAddMonitoringStation: Config.BASE_API_MAPPING.common + 'setupStationLoaderFilter',
    siteSetupAdd: Config.BASE_API_MAPPING.common + 'siteSetupAdd',
    siteSetupUpdate: Config.BASE_API_MAPPING.common + 'siteSetupUpdate',
    siteSetupDelete: Config.BASE_API_MAPPING.common + 'siteSetupDelete',
    fuelSetup: Config.BASE_API_MAPPING.common + 'fuelSetup',
    fuelSetupInsert: Config.BASE_API_MAPPING.common + 'fuelSetupInsert',
    fuelEdit: Config.BASE_API_MAPPING.common + 'fuelEdit',
    fuelDelete: Config.BASE_API_MAPPING.common + 'fuelDelete',
    loadNormalization: Config.BASE_API_MAPPING.common + 'loadNormalization',
    updateNormalization: Config.BASE_API_MAPPING.common + 'updateNormalization',
    networkDetails: Config.BASE_API_MAPPING.common + 'networkDetails',
    updateNetwork: Config.BASE_API_MAPPING.common + 'updateNetwork',
    smsLoader: Config.BASE_API_MAPPING.common + 'smsLoader',
    loadAddSms: Config.BASE_API_MAPPING.common + 'smsFilter',
    smsAdd: Config.BASE_API_MAPPING.common + 'smsAdd',
    smsEdit: Config.BASE_API_MAPPING.common + 'smsEdit',
    fetchShift: Config.BASE_API_MAPPING.common + 'fetchShift',
    loadUser: Config.BASE_API_MAPPING.common + 'loadUser',
    addUser: Config.BASE_API_MAPPING.common + 'addUser',
    editUser: Config.BASE_API_MAPPING.common + 'editUser',
    editPassword: Config.BASE_API_MAPPING.common + 'editPassword',
    configureDashboardType: Config.BASE_API_MAPPING.common + 'configureDashboardType',
    deleteUser: Config.BASE_API_MAPPING.common + 'deleteUser',
    createShift: Config.BASE_API_MAPPING.common + 'createShift',
    deleteShift: Config.BASE_API_MAPPING.common + 'deleteShift',
    uploadLogo: Config.BASE_API_MAPPING.common + 'uploadLogo',
    cylinderSetupLoader: Config.BASE_API_MAPPING.common + 'cylinderSetupLoader',
    addCylinder: Config.BASE_API_MAPPING.common + 'addCylinder',
    deleteCylinder: Config.BASE_API_MAPPING.common + 'deleteCylinder',
    emailConfigSave: Config.BASE_API_MAPPING.common + 'emailConfigSave',
    emailConfigLoader: Config.BASE_API_MAPPING.common + 'emailConfigLoader',
    smsDelete: Config.BASE_API_MAPPING.common + 'smsDelete',
    loadCollector: Config.BASE_API_MAPPING.common + 'loadCollector',
    alertMailConfigLoader: Config.BASE_API_MAPPING.common + 'alertMailConfigLoader',
    alertMailConfigRequest: Config.BASE_API_MAPPING.common + 'alertMailConfigRequest',
    loadUserRole: Config.BASE_API_MAPPING.common + 'loadUserRole',
    addUserRole: Config.BASE_API_MAPPING.common + 'addUserRole',
    editUserRole: Config.BASE_API_MAPPING.common + 'editUserRole',
    deleteUserRole: Config.BASE_API_MAPPING.common + 'deleteUserRole',
    siteConfigLoad: Config.BASE_API_MAPPING.common + 'siteConfigLoad',

    
    loadAddFuelFilter: Config.BASE_API_MAPPING.common + 'fuelSetupFilter',
    loadAddUserFilter: Config.BASE_API_MAPPING.common + 'loadUserFilter',
    loadAddUserRole: Config.BASE_API_MAPPING.common + 'loadUserRoleFilter',
    loadFilter: Config.BASE_API_MAPPING.common + 'siteSetupLoaderFilter',
    // loadAddUserFilter: 'http://192.168.1.62/kl/GLensClient/' + 'loadUserFilter',
    siteConfigSave: Config.BASE_API_MAPPING.common + 'siteConfigSave',
    updateStation: Config.BASE_API_MAPPING.common + 'updateStation',
    deleteStation: Config.BASE_API_MAPPING.common + 'deleteStation',
    loadFlagsetup: Config.BASE_API_MAPPING.common + 'loadFlagsetup',
    addFlagsetup: Config.BASE_API_MAPPING.common + 'addFlagsetup',
    deleteFlagsetup: Config.BASE_API_MAPPING.common + 'deleteFlagsetup',
    editFlagsetup: Config.BASE_API_MAPPING.common + 'editFlagsetup',
    loadQualifierCodeSetup: Config.BASE_API_MAPPING.common + 'loadQualifierCodeSetup',
    qualifierCodeAdd: Config.BASE_API_MAPPING.common + 'qualifierCodeAdd',
    qualifierCodeDelete: Config.BASE_API_MAPPING.common + 'qualifierCodeDelete',
    qualifierCodeUpdate: Config.BASE_API_MAPPING.common + 'qualifierCodeUpdate',
    loadCommentssetup: Config.BASE_API_MAPPING.common + 'loadCommentssetup',
    addCommentSetup: Config.BASE_API_MAPPING.common + 'addCommentSetup',
    commentSetupUpdate: Config.BASE_API_MAPPING.common + 'commentSetupUpdate',
    commentSetupDelete: Config.BASE_API_MAPPING.common + 'commentSetupDelete',
    loadCategorySetup: Config.BASE_API_MAPPING.common + 'loadCategorySetup',
    addCategorySetup: Config.BASE_API_MAPPING.common + 'addCategorySetup',
    categorySetupUpdate: Config.BASE_API_MAPPING.common + 'categorySetupUpdate',
    categorySetupDelete: Config.BASE_API_MAPPING.common + 'categorySetupDelete',
    dm_standard_view: Config.BASE_API_MAPPING.common + 'dm_standard_view',
    save_dm_standard_view: Config.BASE_API_MAPPING.common + 'save_dm_standard_view',
    syncSite: Config.BASE_API_MAPPING.common + 'syncSite',
    syncStation: Config.BASE_API_MAPPING.common + 'syncStation',

    // Active Directory
    loadActiveTable: Config.BASE_API_MAPPING.common + 'loadUser',
    searchUser: Config.BASE_API_MAPPING.common + 'searchUser',
    addUserAD: Config.BASE_API_MAPPING.common + 'addUserFromAd',

    // Advanced Parameter
    advancedSetupLoader: Config.BASE_API_MAPPING.common + 'advancedSetupLoader',
    editadvancedparameter: Config.BASE_API_MAPPING.common + 'editadvancedparameter',
    deleteadvancedparameter: Config.BASE_API_MAPPING.common + 'deleteadvancedparameter',
    addadvancedparameter: Config.BASE_API_MAPPING.common + 'addadvancedparameter',

    // IEDSetup Filter
    iedAssessmentSetup: Config.BASE_API_MAPPING.common + 'iedAssessmentSetup',
    iedassessmentupFetch: Config.BASE_API_MAPPING.common + 'iedassessmentupFetch',
    iedSetupFetch: Config.BASE_API_MAPPING.common + 'iedSetupFetch',
    iedsetup: Config.BASE_API_MAPPING.common + 'iedsetup',

    // parameter setup
    parameterSetupLoader: Config.BASE_API_MAPPING.common + 'parameterSetupLoader',
    orderParameter: Config.BASE_API_MAPPING.common + 'orderParameter',
    deleteParameter: Config.BASE_API_MAPPING.common + 'deleteParameter',
    filterParameter: Config.BASE_API_MAPPING.common + 'filterParameter',
    addParameter: Config.BASE_API_MAPPING.common + 'addParameter',
    editParameter: Config.BASE_API_MAPPING.common + 'parameterSave',
    syncParameterData: Config.BASE_API_MAPPING.common + 'syncParameterData',

    // collector setup
    addCollector: Config.BASE_API_MAPPING.common + 'addCollector',
    CollectorFilter: Config.BASE_API_MAPPING.common + 'collectorFilter',
    deleteCollector: Config.BASE_API_MAPPING.common + 'deleteCollector',
    editloadCollector: Config.BASE_API_MAPPING.common + 'editloadCollector',
    updateCollector: Config.BASE_API_MAPPING.common + 'updateCollector',
    syncCollectorData: Config.BASE_API_MAPPING.common + 'syncCollectorData',


    // batch running
    batchesList: Config.BASE_API_MAPPING.restart + 'batchesList',
    changebatchStatus: Config.BASE_API_MAPPING.restart + 'changebatchStatus',
    addBatch: Config.BASE_API_MAPPING.restart + 'addBatch',
    fetchBatch: Config.BASE_API_MAPPING.restart + 'fetchBatch',
    fetchBatchForm: Config.BASE_API_MAPPING.restart + 'fetchBatchForm',
    // service-operations
    fetchServicesList: Config.BASE_API_MAPPING.restart + 'fetchServicesList',
    changeServiceStatus: Config.BASE_API_MAPPING.restart + 'changeServiceStatus',

    // Display Board
    displayLoad: Config.BASE_API_MAPPING.common + 'displayLoad',
    displayAdd: Config.BASE_API_MAPPING.common + 'displayAdd',
    displayDelete: Config.BASE_API_MAPPING.common + 'displayDelete',
    displayEditSave: Config.BASE_API_MAPPING.common + 'displayEditSave',
    generateDisplayConfigFile: Config.BASE_API_MAPPING.common + 'generateDisplayConfigFile',


    // printer
    CsvDump: Config.BASE_API_MAPPING.common + 'generateCSVReport',
    PdfDump: Config.BASE_API_MAPPING.common + 'generatePDFReport',
    ExcelDump: Config.BASE_API_MAPPING.common + 'generateXLReport',
    WordDump: Config.BASE_API_MAPPING.common + 'generateWORDReport',
    HTMLDump: Config.BASE_API_MAPPING.common + 'generateHTMLReport',
    pdfUrl: Config.BASE_API_MAPPING.common + 'pdfFileHandler',
    download: Config.BASE_API_MAPPING.common + 'download',
    aermod_download: Config.BASE_API_MAPPING.common + 'aermod_download',
    siteConfUrl: Config.BASE_API_MAPPING.common + 'siteConfFileHandler',
    colorPrint: Config.BASE_API_MAPPING.common + 'colorPrint',

    // AQI Reports
    AQIDataReport: Config.BASE_API_MAPPING.common + 'AQIDataReport',
    AQILevelReport: Config.BASE_API_MAPPING.common + 'AQILevelReport',
    AQIMonthlyCalenderView: Config.BASE_API_MAPPING.common + 'AQIMonthlyCalenderView',
    AQIHourlyCalenderView: Config.BASE_API_MAPPING.common + 'AQIHourlyCalenderView',
    standard_listing: Config.BASE_API_MAPPING.common + 'standard_listing',
    standard_view: Config.BASE_API_MAPPING.common + 'standard_view',
    standard_generation: Config.BASE_API_MAPPING.common + 'standard_generation',
    standard_delete: Config.BASE_API_MAPPING.common + 'standard_delete',


    // Complaints complaint
    complaintsManagementFilter: Config.BASE_API_MAPPING.common + 'complaintsManagementFilter',
    fetchComplainList: Config.BASE_API_MAPPING.complaint + 'fetchComplainList',
    fetchComplainStats: Config.BASE_API_MAPPING.complaint + 'fetchComplainStats',
    viewComplaintLoader: Config.BASE_API_MAPPING.complaint + 'fetchComplainDetail',
    deleteComplaint: Config.BASE_API_MAPPING.complaint + 'deleteComplaint',
    complaintDownload: Config.BASE_API_MAPPING.complaint + 'download',
    inspectionOnload: Config.BASE_API_MAPPING.complaint + 'inspectionOnload',
    addInspection: Config.BASE_API_MAPPING.complaint + 'addInspection',
    inspectionTable: Config.BASE_API_MAPPING.complaint + 'inspectionTable',
    excelReport: Config.BASE_API_MAPPING.complaint + 'excelReport',
    editInspection: Config.BASE_API_MAPPING.complaint + 'editInspection',

    complaintAssignment: Config.BASE_API_MAPPING.complaint + 'updateAction',
    updateStatus: Config.BASE_API_MAPPING.complaint + 'updateStatus',
    pdfDownload: Config.BASE_API_MAPPING.complaint + 'pdfDownload',
    loadSetup: Config.BASE_API_MAPPING.complaint + 'loadSetup',
    updateSetup: Config.BASE_API_MAPPING.complaint + 'updateSetup',

    requestHeadersStationwiseReport: Config.BASE_API_MAPPING.common + 'formJsonLoader',
    inspectionFormJson: Config.BASE_API_MAPPING.complaint + 'inspectionFormJson',
    inspectionDownload: Config.BASE_API_MAPPING.complaint + 'inspectionDownload',
    aqmsReportTable: Config.BASE_API_MAPPING.complaint + 'aqmsReportTable',
    fileUpload: Config.BASE_API_MAPPING.complaint + 'fileUpload',
    AQMSDownload: Config.BASE_API_MAPPING.complaint + 'aqmsDownload',


    // aermod
    // get_all_projects: Config.BASE_API_MAPPING.aermod + 'get_all_projects',
    // get_project_generated: Config.BASE_API_MAPPING.aermod + 'get_project_generated',
    // fetch_all_sites: Config.BASE_API_MAPPING.aermod + 'fetch_all_sites',
    // fetch_site_metadata: Config.BASE_API_MAPPING.aermod + 'fetch_site_metadata',
    // fetch_list_of_buildings: Config.BASE_API_MAPPING.aermod + 'fetch_list_of_buildings',
    // get_site_terrain_details: Config.BASE_API_MAPPING.aermod + 'get_site_terrain_details',
    // // reportDownload: Config.BASE_API_MAPPING.aermodDownload + 'reports',
    // insert_building_component: Config.BASE_API_MAPPING.aermod + 'insert_building_component',
    // save_project_details: Config.BASE_API_MAPPING.aermod + 'save_project_details',
    // update_building_component: Config.BASE_API_MAPPING.aermod + 'update_building_component',
    // generate_heatmap: Config.BASE_API_MAPPING.aermod + 'generate_heatmap',
    // get_project_details: Config.BASE_API_MAPPING.aermod + 'get_project_details',
    // change_heatmap_levels: Config.BASE_API_MAPPING.aermod + 'change_heatmap_levels',

    get_all_projects: Config.BASE_API_MAPPING.common + 'get_all_projects',
    get_project_generated: Config.BASE_API_MAPPING.common + 'get_project_generated',
    fetch_all_sites: Config.BASE_API_MAPPING.common + 'fetch_all_sites',
    fetch_site_metadata: Config.BASE_API_MAPPING.common + 'fetch_site_metadata',
    fetch_list_of_buildings: Config.BASE_API_MAPPING.common + 'fetch_list_of_buildings',
    get_site_terrain_details: Config.BASE_API_MAPPING.common + 'get_site_terrain_details',
    // reportDownload: Config.BASE_API_MAPPING.aermodDownload + 'reports',
    insert_building_component: Config.BASE_API_MAPPING.common + 'insert_building_component',
    save_project_details: Config.BASE_API_MAPPING.common + 'save_project_details',
    update_building_component: Config.BASE_API_MAPPING.common + 'update_building_component',
    generate_heatmap: Config.BASE_API_MAPPING.common + 'generate_heatmap',
    get_project_details: Config.BASE_API_MAPPING.common + 'get_project_details',
    change_heatmap_levels: Config.BASE_API_MAPPING.common + 'change_heatmap_levels',

    // AqiDataEntry
    AqiDataEntry: Config.BASE_API_MAPPING.common + 'AqiDataEntry',
    aqiEntryParamsMetaData: Config.BASE_API_MAPPING.common + 'aqiEntryParamsMetaData',

    // Noise Modelling
    noiseModellingUpload: Config.BASE_API_MAPPING.common + 'noiseDataUpload',
    noiseModellingTable: Config.BASE_API_MAPPING.common + 'noiseLogData',
    noiseModellingHeatMap: Config.BASE_API_MAPPING.common + 'noiseHeatMapData',
    noiseModellingReportDownload: Config.BASE_API_MAPPING.common + '',
    // Scada view
    getSldList: Config.BASE_API_MAPPING.common + 'scada_side_bar',
    getFilteredSites: Config.BASE_API_MAPPING.common + 'scada_site_hierarchy',
    createSLD: Config.BASE_API_MAPPING.common + 'scada_import',
    get_template: Config.BASE_API_MAPPING.common + 'scada_get_template',
    update_sld: Config.BASE_API_MAPPING.common + 'scada_update',
    download_hmi_file: Config.BASE_API_MAPPING.common + 'scada_export',
    get_sld_tag_extention: Config.BASE_API_MAPPING.common + 'scada_live_topics',
    scada_delete: Config.BASE_API_MAPPING.common + 'scada_delete',
    scada_edit_save: Config.BASE_API_MAPPING.common + 'scada_edit',
    // scada_edit

    getwritterTopics: Config.BASE_API_MAPPING.common + 'get_topic_list',
    getHMICurrentUserDetails: Config.BASE_API_MAPPING.common + 'current_user_details',
    getHighAvailabilityTags: Config.BASE_API_MAPPING.common + 'high_availibity_topics',
    widget_details: Config.BASE_API_MAPPING.common + 'widget_details',
    getReportMenus: Config.BASE_API_MAPPING.common + 'report/list',
    getUserWorkGroupList: Config.BASE_API_MAPPING.common + 'user_workgroup_list',
    saveWidgetConfigData: Config.BASE_API_MAPPING.common + 'widget/save',
    getWidgetDetails: Config.BASE_API_MAPPING.common + 'widget/widget_details',
    updateDecimal: Config.BASE_API_MAPPING.common + 'updateDecimal',

    // Camera Setup
    getCameraDropDowns: Config.BASE_API_MAPPING.common + 'getSiteStationList',
    getCameraList: Config.BASE_API_MAPPING.common + 'getAllCameraDetails',
    addEditDeleteCamera: Config.BASE_API_MAPPING.common + 'configureCamera',
    // streamCamera: Config.BASE_API_MAPPING.common + 'stream',
    streamCamera: Config.BASE_API_MAPPING.socket + 'stream',

    socketUrlImg: '/',

  // Calibration Certificate
  loadCalibrationCertificate: Config.BASE_API_MAPPING.common + 'loadCalibrationCertificate',
  loadConfiguredSites: Config.BASE_API_MAPPING.common + 'loadConfiguredSites',
  loadConfiguredStations: Config.BASE_API_MAPPING.common + 'loadConfiguredStations',
  addCalibrationCertificate: Config.BASE_API_MAPPING.common + 'addCalibrationCertificate',
  viewCalibrationCertificate: Config.BASE_API_MAPPING.common + 'viewCalibrationCertificate',

    // Hindalco dashboard
    siteData: Config.BASE_API_MAPPING.common + 'hindalcoDashboardData',

    // mail service table
    mailServiceList: Config.BASE_API_MAPPING.common + 'mailTblData',

    // Dropdowns data for Mail service
    mailServiceAdd: Config.BASE_API_MAPPING.common + 'mailJsonLoader',
    
    requestEPDACustomReport: Config.BASE_API_MAPPING.common + 'requestEPDACustomReport',

    // Adding and Editing mail data
    mailData: Config.BASE_API_MAPPING.common + 'mailData',

    // Deleting mail data
    deleteMailData: Config.BASE_API_MAPPING.common + 'delMailData',

    //Cylinder Setup
    cylinderAdd: Config.BASE_API_MAPPING.common + 'cylinderAdd',

    //Utilities
    uModbusUtility: Config.BASE_API_MAPPING.common + 'modbusUtility',
    uModbusScan: Config.BASE_API_MAPPING.common + 'modbusScan',

    //rain report
    rainReportLoader: Config.BASE_API_MAPPING.common + 'rainReportLoader',
    requestRainReport: Config.BASE_API_MAPPING.common + 'requestRainReport',

    //Workflows
    workFlowTable: Config.BASE_API_MAPPING.common + 'workFlowTable',
    addFilters: Config.BASE_API_MAPPING.common + 'addFilters',
    addWorkFlow: Config.BASE_API_MAPPING.common + 'addWorkFlow',

    //exeedence alerts page for hindalco
    alertSetupList: Config.BASE_API_MAPPING.common + 'alertSetupList',
    alertSetupSave: Config.BASE_API_MAPPING.common + 'alertSetupSave',
    alertSetupDelete: Config.BASE_API_MAPPING.common + 'alertSetupDelete',
    
    // USA PART 60 REPORTS
    viewUSAReport: Config.BASE_API_MAPPING.common + 'viewUSAReport',
    getSiteListUSA: Config.BASE_API_MAPPING.common + 'getSiteListUSA',
    getStationListUSA: Config.BASE_API_MAPPING.common + 'getStationListUSA',
    getParameterListUSA: Config.BASE_API_MAPPING.common + 'getParameterListUSA',
    saveUSAReport: Config.BASE_API_MAPPING.common + 'saveUSAReport',
    deleteUSAReport: Config.BASE_API_MAPPING.common + 'deleteUSAReport',
    downloadUSAHourlyReport: Config.BASE_API_MAPPING.common + 'downloadUSAHourlyReport',
    download30dValueReport: Config.BASE_API_MAPPING.common + 'download30dValueReport',
    downloadMonitorDownTime: Config.BASE_API_MAPPING.common + 'downloadMonitorDownTime',
    downloadMonitorDeviationReport: Config.BASE_API_MAPPING.common + 'downloadMonitorDeviationReport',
    downloadSummaryReport: Config.BASE_API_MAPPING.common + 'downloadSummaryReport',
    editUSAReport: Config.BASE_API_MAPPING.common + 'editUSAReport',
    saveUSATable: Config.BASE_API_MAPPING.common + 'saveUSATable',
    
    // GENERAL SETTINGS
    loadEPDAUser: Config.BASE_API_MAPPING.common + 'loadEPDAUser',
    uploadEPDALogo: Config.BASE_API_MAPPING.common + 'uploadEPDALogo',
    runTimeFrequency: Config.BASE_API_MAPPING.common + 'runTimeFrequency',
    runTimeFrequencyLoader: Config.BASE_API_MAPPING.common + 'runTimeFrequencyLoader',
  
    // THERMOFISHER UTILITY
    getThermofisherDasboard: Config.BASE_API_MAPPING.common + 'getThermofisherDasboard',
    thermofisherCollector: Config.BASE_API_MAPPING.common + 'thermofisherCollector',

  };

  // Alert messages to show in Application
  public static ALERT_MESSAGES: any = {
  };
  public static CONSTANTS: any = {
    LEAFLETTILES: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
  };

  public static DUP_USER = {
    input: {
      name: 'sivaram', key: 'glensDevTeam@123'
    },
    // tslint:disable-next-line:max-line-length
    res: 'eyJkYXRhIjogeyJzdGF0dXMiOiAic3VjY2VzcyIsICJzaXRlSWQiOiAic2l0ZV8xMDEiLCAic2l0ZU5hbWUiOiAiQVEgSEMsRnVqYWlyYWgiLCAidXNlclJvbGUiOiAiQWRtaW4iLCAiZmFpbHVyZUNvdW50IjogIjAiLCAibWNlcnQiOiAiZmFsc2UiLCAic3RhdGlvbl9saXN0IjogIkFRX0hDLFFpZGZhLE1vYmlsZV9TdGF0aW9uLExhZmFyZ2VfQ2VtcyxGTSwyMSw3NiIsICJkYXNoYm9hcmRUeXBlIjogIm1hcFZpZXciLCAidXNlcklkIjogImdsZW5zQWRtaW4iLCAicmVmcmVzaFRpbWUiOiA2MDAwMCwgIm1lc3NhZ2UiOiAiIiwgImxhc3RMb2dpbiI6ICIyNy0wMS0yMDIwIDE5OjE4OjAxIn0sICJzdGF0dXMiOiB0cnVlLCAibWVzc2FnZSI6ICJMb2dpbiBTdWNjZXNzZnVsIn0='
  };

  public static logger(data) {
    try {
      console.log(data);
    } catch (error) {
      console.log(error);
    }
  }
}
